// Module
var code = " <app-main></app-main> ";
// Exports
module.exports = code;